import React from "react"

import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"
import {BREAKDOWN_ALL_VALUES} from "../../../../gd-modules/tasks-view/core/@const"

const debug = false
// const debug = "FieldRAG_QuickFilterView"

const RAG_LABELS: Record<number, string> = {
    0: 'Red',
    1: 'Amber',
    2: 'Green',
}

export default function FieldRAG_QuickFilterView(props: FieldQuickFilterViewProps) {
    const {value} = props

    debug && console.log(debug, 'render', value, typeof value)

    switch (value) {
        case BREAKDOWN_ALL_VALUES:
            return <div className="name">All values</div>

        default:
            const ragValue = typeof value === 'string' ? parseInt(value) : value

            const classes = Classes("ui5-ico-rag lh-20", {
                'red'   : ragValue === 0,
                'amber' : ragValue === 1,
                'green' : ragValue === 2,
            })

            const label = RAG_LABELS[ragValue] ?? 'Not set'

            return (
                <div className="flex-row-left-center">
                    <div className={classes}/>
                    <div className="ui5-txt-less-important m-l-10">{label}</div>
                </div>
            )
    }
}